import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import type { UiDiscomfortLevel } from '../lib/calibration/onboardingConstants'
import type { TrainingAge, TrainingGoal } from '../lib/calibrationTypes'

const TRAINING_GOAL_VALUES: TrainingGoal[] = ['strength', 'hypertrophy', 'conditioning_weight_loss']
const TRAINING_AGE_VALUES: TrainingAge[] = ['beginner', 'intermediate', 'advanced']
const DISCOMFORT_VALUES: UiDiscomfortLevel[] = ['low', 'medium', 'high']

const DISCOMFORT_TONES: Record<UiDiscomfortLevel, string> = {
  low: 'border-emerald-500/50 bg-emerald-500/10 text-emerald-300',
  medium: 'border-amber-500/50 bg-amber-500/10 text-amber-300',
  high: 'border-red-500/50 bg-red-500/10 text-red-300',
}

export function useCalibrationCopy() {
  const { t } = useTranslation()

  return useMemo(
    () => ({
      trainingGoalOptions: TRAINING_GOAL_VALUES.map((value) => ({
        value,
        label: t(`onboarding.calibration.trainingGoals.${value}.label`),
        hint: t(`onboarding.calibration.trainingGoals.${value}.hint`),
      })),
      trainingAgeOptions: TRAINING_AGE_VALUES.map((value) => ({
        value,
        label: t(`onboarding.calibration.trainingAges.${value}.label`),
        hint: t(`onboarding.calibration.trainingAges.${value}.hint`),
      })),
      discomfortLevels: DISCOMFORT_VALUES.map((value) => ({
        value,
        label: t(`onboarding.calibration.discomfort.${value}`),
        tone: DISCOMFORT_TONES[value],
      })),
    }),
    [t],
  )
}
